import React from 'react';
import HeroImage from '../assets/herosec_image.af584ed6.jpg';

const EAPHeroSection: React.FC = () => {
  return (
    <div className="relative min-h-screen flex flex-col justify-center items-center px-4 bg-cover bg-center"
         style={{
           backgroundImage: `url(${HeroImage})`
         }}>
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black/30"></div>
      
      {/* Hero Content */}
      <div className="text-center max-w-6xl mx-auto relative z-10">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-normal text-white mb-6">
          Employee Assistance Programme Services
        </h1>
        
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-normal text-white mb-12">
          The Best UK EAP Service Provider
        </h2>
        
        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-lg md:text-xl text-white text-center leading-relaxed">
            Boost Employee Well-Being and Reduce Absenteeism with Effective EAP Solutions. 
            Build a thriving, positive, productive workplace for your employees.
          </p>
        </div>
        
        {/* CTA Button */}
        <button className="bg-gray-700 hover:bg-gray-800 text-white text-2xl md:text-3xl font-bold px-12 py-6 transition-colors duration-300 rounded-lg shadow-lg hover:shadow-xl">
          Request a Demo
        </button>
      </div>
    </div>
  );
};

export default EAPHeroSection;